import { EMPTY_OBJECT } from '../../../../constants/common'
import {
  GRETA_PROJECT_NAME_MAX_LENGTH,
  GretaAIChatChatActionType,
  QA_NAME_GRETA_AI_CHAT_PROJECT_RENAME_INPUT,
} from '../../GretaAIChat.constants'
import { getIsGretaAIChatProjectGenerating } from '../../GretaAIChat.utils.projects'
import { GretaAIChatProjectDeleteConfirmation } from '../../GretaAIChatProjectDeleteConfirmation'
import { GretaAIChatRenameModal } from '../../GretaAIChatRenameModal'

export function getGretaAIChatPanelProjectActionContent({
  chatStatusById,
  projectAction,
  t,
  onCancel,
  onConfirmDelete,
  onConfirmRename,
}) {
  const { project, type } = projectAction ?? EMPTY_OBJECT

  switch (type) {
    case GretaAIChatChatActionType.Rename:
      return (
        <GretaAIChatRenameModal
          hasCounter
          errorText={t('Greta.ProjectRenameErrorKey')}
          maxLength={GRETA_PROJECT_NAME_MAX_LENGTH}
          name={project.name}
          placeholder={t('Greta.ProjectNamePlaceholderKey')}
          qaName={QA_NAME_GRETA_AI_CHAT_PROJECT_RENAME_INPUT}
          title={t('Greta.ProjectRenameTitleKey')}
          onCancel={onCancel}
          onSubmit={onConfirmRename}
        />
      )
    case GretaAIChatChatActionType.Delete:
      return (
        <GretaAIChatProjectDeleteConfirmation
          isGenerating={getIsGretaAIChatProjectGenerating(
            project.chats,
            chatStatusById
          )}
          project={project}
          onCancel={onCancel}
          onConfirm={onConfirmDelete}
        />
      )
    default:
      return null
  }
}
